// Minimal Turnstile loader. The script is lazy-injected into <head> the first
// time something asks for it; subsequent calls reuse the same load promise.
// Keeps the script out of the initial bundle for users who never reach the
// email gate.

declare global {
  interface Window {
    turnstile?: {
      render: (
        container: string | HTMLElement,
        options: {
          sitekey: string;
          callback: (token: string) => void;
          'error-callback'?: () => void;
          'expired-callback'?: () => void;
          theme?: 'light' | 'dark' | 'auto';
          size?: 'normal' | 'compact' | 'flexible';
        }
      ) => string;
      reset: (widgetId?: string) => void;
      remove: (widgetId: string) => void;
    };
  }
}

const SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let loadPromise: Promise<void> | null = null;

export function loadTurnstile(): Promise<void> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      // The script defines window.turnstile synchronously on load; if it's
      // missing, treat as a load failure.
      if (window.turnstile) resolve();
      else reject(new Error('Turnstile failed to initialise.'));
    };
    script.onerror = () => reject(new Error('Could not load Turnstile.'));
    document.head.appendChild(script);
  });

  return loadPromise;
}

export const TURNSTILE_SITE_KEY: string =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? '';
